import { inject, Injectable } from '@angular/core'
import { _objectKeys } from '@naturalcycles/js-lib'
import { getBucket } from '@naturalcycles/shared'
import { Breadcrumb } from '@sentry/angular'
import { SignalStore } from '../store/signalStore.js'
import { sentry } from '../util/sentry.util.js'

@Injectable({ providedIn: 'root' })
export class SentryService {
  private store = inject(SignalStore)

  addBreadcrumb(breadcrumb: Breadcrumb): void {
    this.setGlobalTags()
    sentry.addBreadcrumb(breadcrumb)
  }

  captureMessage(message: string): void {
    this.setGlobalTags()
    sentry.captureMessage(message)
  }

  captureException(exception: any): void {
    this.setGlobalTags()
    sentry.captureException(exception)
  }

  private setGlobalTags(): void {
    for (const key of _objectKeys(this.store.$experiment().assignments)) {
      const bucket = getBucket(this.store.$experiment().assignments[key])
      if (!bucket) continue

      sentry.setTags({
        [key]: bucket,
      })
    }
  }
}
